
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalCharging75 as ObiBatteryVerticalCharging75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-charging-75.js';
 
 
 

 
 export const ObiBatteryVerticalCharging75 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-charging-75',
   elementClass: ObiBatteryVerticalCharging75Element,
   events: {
     
   }
  });
 
 